import * as React from "react";
import Terminos from "../containers/terminos";

export default function TerminosYCondiciones() {
  return <Terminos></Terminos>;
}
